import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeToggleComponent } from '../../../shared/components/theme-toggle/theme-toggle.component';
import { BorderBeamComponent } from '@/app/shared/components/ui/border-beam/border-beam.component';
import { ParticlesComponent } from '@/app/shared/components/ui/particles/particles.component';
import { MagicCardComponent } from '@/app/shared/components/ui/magic-card/magic-card.component';

@Component({
  standalone: true,
  selector: 'app-public-layout',
  imports: [
    CommonModule,
    ThemeToggleComponent,
    BorderBeamComponent,
    ParticlesComponent,
    MagicCardComponent,
  ],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent implements OnInit {
  isMobileMenuOpen = false;
  isVideoModalOpen = false;
  isDarkTheme = true;
  cardsData = [
    {
        image: 'assets/images/avatar/avatar_1.png',
        name: 'Sarah Mitchell',
        title: 'VP of Sales, TechFlow Inc',
        date: 'April 20, 2025',
        review: 'B2B CRM has transformed how we manage our sales pipeline. The automation features alone have saved us 20+ hours per week, and our conversion rates have increased by 40%.',
    },
    {
      image: 'assets/images/avatar/avatar_2.png',
      name: 'Jennifer Chen',
      title: 'CTO, InnovateLab',
      date: 'June 5, 2025',
      review: 'Implementation was seamless and the support team is outstanding. B2B CRM integrates perfectly with our existing tools and has streamlined our entire sales process.',
    },
    {
        image: 'assets/images/avatar/avatar_3.png',
        name: 'Michael Rodriguez',
        title: 'CEO, Growth Dynamics',
        date: 'May 10, 2025',
        review: 'The insights and analytics provided by B2B CRM are game-changing. We can now make data-driven decisions that have improved our revenue by 60% year-over-year.',
    },
    {
        image: 'assets/images/avatar/avatar_4.png',
        name: 'David Kim',
        title: 'Sales Director, ScaleUp Solutions',
        date: 'May 10, 2025',
        review: 'Our team productivity has skyrocketed since switching to B2B CRM. The intuitive interface and powerful features make managing our customer relationships effortless.',
    },
    {
        image: 'assets/images/avatar/avatar_5.png',
        name: 'Lisa Wang',
        title: 'Head of Operations, FutureTech',
        date: 'May 10, 2025',
        review: 'The ROI has been incredible. B2B CRM paid for itself within the first month through improved lead conversion and reduced manual work. Highly recommended!',
    },
    {
      image: 'assets/images/avatar/avatar_6.png',
      name: 'Alex Thompson',
      title: 'Founder, StartupFlow',
      date: 'May 10, 2025',
      review: 'As a fast-growing startup, we needed a CRM that could scale with us. B2B CRM has exceeded our expectations and continues to evolve with our needs.',
    },
  ];

  ngOnInit(): void {
    const row1 = document.getElementById('row1');
    const row2 = document.getElementById('row2');
    this.renderCards(row1);
    this.renderCards(row2);
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  openVideoModal() {
    this.isVideoModalOpen = true;
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  closeVideoModal() {
    this.isVideoModalOpen = false;
    // Restore body scroll
    document.body.style.overflow = 'auto';
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if (this.isVideoModalOpen) {
      this.closeVideoModal();
    }
  }

  onThemeChange(isDarkMode: boolean) {
    this.isDarkTheme = isDarkMode;
  }

  createCard = (card: any) => `
    <div class="p-4 rounded-lg mx-4 shadow hover:shadow-lg transition-all duration-200 w-72 shrink-0 bg-background dark:bg-foreground">
      <div class="flex gap-2">
        <img class="size-11 rounded-full" src="${card.image}" alt="User Image">
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <p class="text-foreground dark:text-background">${card.name}</p>
            <svg class="mt-0.5" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.555.72a4 4 0 0 1-.297.24c-.179.12-.38.202-.59.244a4 4 0 0 1-.38.041c-.48.039-.721.058-.922.129a1.63 1.63 0 0 0-.992.992c-.071.2-.09.441-.129.922a4 4 0 0 1-.041.38 1.6 1.6 0 0 1-.245.59 3 3 0 0 1-.239.297c-.313.368-.47.551-.56.743-.213.444-.213.96 0 1.404.09.192.247.375.56.743.125.146.187.219.24.297.12.179.202.38.244.59.018.093.026.189.041.38.039.48.058.721.129.922.163.464.528.829.992.992.2.071.441.09.922.129.191.015.287.023.38.041.21.042.411.125.59.245.078.052.151.114.297.239.368.313.551.47.743.56.444.213.96.213 1.404 0 .192-.09.375-.247.743-.56.146-.125.219-.187.297-.24.179-.12.38-.202.59-.244a4 4 0 0 1 .38-.041c.48-.039.721-.058.922-.129.464-.163.829-.528.992-.992.071-.2.09-.441.129-.922a4 4 0 0 1 .041-.38c.042-.21.125-.411.245-.59.052-.078.114-.151.239-.297.313-.368.47-.551.56-.743.213-.444.213-.96 0-1.404-.09-.192-.247-.375-.56-.743a4 4 0 0 1-.24-.297 1.6 1.6 0 0 1-.244-.59 3 3 0 0 1-.041-.38c-.039-.48-.058-.721-.129-.922a1.63 1.63 0 0 0-.992-.992c-.2-.071-.441-.09-.922-.129a4 4 0 0 1-.38-.041 1.6 1.6 0 0 1-.59-.245A3 3 0 0 1 7.445.72C7.077.407 6.894.25 6.702.16a1.63 1.63 0 0 0-1.404 0c-.192.09-.375.247-.743.56m4.07 3.998a.488.488 0 0 0-.691-.69l-2.91 2.91-.958-.957a.488.488 0 0 0-.69.69l1.302 1.302c.19.191.5.191.69 0z" fill="#2196F3" />
            </svg>
          </div>
          <span class="text-xs text-slate-500">${card.title}</span>
        </div>
      </div>
      <p class="text-sm pt-4 text-gray-800">
        ${card.review}
      </p>
    </div>
  `;

  renderCards = (target: any) => {
    const doubled = [...this.cardsData, ...this.cardsData];
    doubled.forEach(card => target.insertAdjacentHTML('beforeend', this.createCard(card)));
  };

}
